module.exports = __webpack_public_path__ + "static/img/Motn-MC-V.c74d8c9d.jpg";